import React, { useContext, useState } from "react";
import { get, isEmpty } from "lodash";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import {
  faTimes,
  faTrashAlt,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import {
  ManagePlanLayout,
  FieldDropSide,
  FieldTextarea,
  DatePicker,
  DeleteWarning,
  FieldButtonGroup,
  FieldInputYearBox,
  FieldInputMonthBox,
  FieldInput,
  MultiSelectDropdown,
} from "../../../components";

import {
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  required,
  usDateFormat,
  transformToMultiselectSave,
  getParamsFromQueryString,
  yesNoOptions,
  LTPTServiceCreditPeriod,
  LTPTVestingComputationPeriod,
  toMultiSelectValueById,
} from "../../../utils";
import {
  createPlanStore,
  setManagePlanLocalCache,
  setManagePlanToastInfo,
} from "../../../contexts";
import {
  useDeepEffect,
  useRequest,
  useRouterParams,
  useTableChecboxSelect,
} from "../../../abstracts";
import AdditionalExclusionsForm from "../AddEligibilityContainer/AdditionalExclusionsForm";
import EligibilityRuleForm from "../AddEligibilityContainer/EligibilityRuleForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getPlanEligibilityMasterData,
  getClassificationCodes,
  getValidation,
  listSource,
} from "../../../services";
import AdditionalEligibilityRuleForm from "../AddEligibilityContainer/AdditionalEligibilityRuleForm";

const initialValues = {};

const AdditionalEligibilityRuleContainer = (props) => {
  const { state, dispatch } = useContext(createPlanStore);
  const { history } = props;
  const {
    flow,
    planId,
    eligibilityIndex,
    planAmendmentId,
    clickedOn,
    additionalEligibilityId,
  } = useRouterParams();
  const dirtyCheck = getParamsFromQueryString("dirtyCheck");

  const formName = managePlanFormNames.ADDITIONAL_ELIGIBILITY_RULE;
  const fields = formFields[formName];
  const intEligibilityIndex = parseInt(eligibilityIndex, 0);
  const eligibilityListData = get(state, "eligibilityRules", []);
  const [showWarning, setShowWarning] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState([]);
  const [employeeSources, setEmployeeSource] = useState([]);

  const date = new Date("2024,01,01");

  useDeepEffect(() => {
    listSource(parseInt(planId))
      .then((response) => {
        setEmployeeSource(
          response?.employerSourcesList
            ?.filter((val) => val.sourceType == 1 && val.sourceCategory == 2)
            ?.map((source) => ({
              label: source.sourceName,
              value: source.id,
            }))
        );
      })
      .catch((error) => {
        //Handle Error
      });
  }, []);

  const planData = get(state, "api.reviewAndPlanDetail", {});
  const additionalEligibilityRulesData = get(
    eligibilityListData,
    "additionalEligibilityRules",
    []
  );
  const formValues = get(
    additionalEligibilityRulesData,
    additionalEligibilityId,
    {}
  );
  const formValuesExcludedClassifications = get(
    formValues,
    "excludedClassifications",
    []
  );
  const DeleteToastMessage =
    "You are attempting to delete additional eligibility rule.";
  const DeleteToastMessageHead = "Delete Additional Eligibility Rule?";
  const [newFlow, setNewFlow] = useState(flow);
  const handleConfirmClick = () => {
    var additionalRule = additionalEligibilityRulesData.filter(
      (additionalEligibility, index) =>
        index == parseInt(additionalEligibilityId)
    );
    if (additionalRule !== null && additionalRule[0]?.id) {
      const data = {
        id: additionalRule[0]?.id,
        typeId: 3,
      };
      getValidation(data).then((response) => {
        if (response.errorMessage !== null) {
          setShowPopup(true);
          setErrorMessage(response.errorMessage);
          setShowWarning(false);
        } else {
          deleteAdditionalRule();
        }
      });
    } else {
      deleteAdditionalRule();
    }
  };
  const deleteAdditionalRule = () => {
    var eligData = {
      ...eligibilityListData,
      additionalEligibilityRules: additionalEligibilityRulesData.filter(
        (additionalEligibility, index) =>
          index !== parseInt(additionalEligibilityId)
      ),
    };
    // var eligData = eligibilityListData.map((item, index) => {
    //   if (index === intEligibilityIndex) {
    //     let eligibility = {
    //       ...item,
    //       additionalEligibilityRules: additionalEligibilityRulesData.filter(
    //         (additionalEligibility, index) =>
    //           index !== parseInt(additionalEligibilityId)
    //       ),
    //     };
    //     return eligibility;
    //   }
    //   return item;
    // });
    dispatch(
      setManagePlanLocalCache({
        model: "eligibilityRules",
        data: eligData,
      })
    );
    history.push(
      getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY,
        pathParam: [
          FLOW_TYPES.SAVE,
          planId,
          eligibilityIndex,
          planAmendmentId,
          clickedOn,
        ],
        queryParam: `?dirtyCheck=${dirtyCheck}`,
      })
    );
    dispatch(
      setManagePlanToastInfo({
        showToast: true,
        toastMessage: `Data deleted successfully`,
      })
    );
  };

  const onDeleteClick = () => {
    setShowWarning(true);
  };
  const handleCancelClick = () => {
    setShowWarning(false);
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY,
        pathParam: [
          newFlow,
          planId,
          eligibilityIndex,
          planAmendmentId,
          clickedOn,
        ],
        queryParam: `?dirtyCheck=${dirtyCheck}`,
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY,
        pathParam: [
          FLOW_TYPES.SAVE,
          planId,
          eligibilityIndex,
          planAmendmentId,
          clickedOn,
        ],
        queryParam: `?dirtyCheck=${dirtyCheck}`,
      }),
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => setNewFlow(FLOW_TYPES.SAVE),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: onDeleteClick,
    },
    // {
    //   label: "Edit",
    //   variant: "primary",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   onClick: () => setNewFlow(FLOW_TYPES.SAVE),
    // },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTrashAlt,
    //   onClick: onDeleteClick,
    // },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];

  let defaultEffectiveDate = new Date("2024,01,01");

  const getDataForSave = (values) => {
    const {
      // isBreakInService,
      // breakInServiceDefinition,
      // consecutiveBreaksInService,
      yearsOfServiceDefinition,
      age,
      ageMonth,
      hours,
      yearsOfServiceHours,
      eligibilityCalculationPeriod,
      otherComputationalMonths,
      yearsOfServiceRequirement,
      serviceCreditPeriod,
      serviceCreditDay,
      period,
      lengthOfService,
      eligibilityRequirementMetDate,
      eligibilityBreakInServices,
      eligibilityType,
      immediateEligibility,
      isRevaluationRequired,
      daily,
      exclusionRuleId,
      weekly,
      biweekly,
      semiMonthly,
      monthly,
      quarterly,
      semiAnnually,
      annually,
      hireDateType,
      exclusionType,
      // isLTPTApplicable,
      // ltptAgeInMonths,
      // ltptAgeInYears,
      // ltptHours,
      // consecutiveYears,
      // ltptVestingComputationPeriod,
      // ltptServiceCreditPeriod,
      // applicableEmployeeSourceForLTPT,
      //effectiveDate,
      ...rest
    } = values;
    const formatedValues = {
      ...formValues,
      ...rest,
      immediateEligibility: immediateEligibility,
      // isLTPTApplicable: isLTPTApplicable,
      // ltptAgeInMonths: ltptAgeInMonths,
      // ltptAgeInYears: ltptAgeInYears,
      // ltptHours: ltptHours,
      // consecutiveYears: consecutiveYears,
      // ltptVestingComputationPeriod: ltptVestingComputationPeriod,
      // ltptServiceCreditPeriod: ltptServiceCreditPeriod,
      // applicableEmployeeSourceForLTPT: transformToMultiselectSave(
      //   applicableEmployeeSourceForLTPT,
      //   "sourceId"
      // ),
      // effectiveDate: effectiveDate,

      eligibilityType: eligibilityType || undefined,
      yearsOfServiceDefinition: yearsOfServiceDefinition || undefined,
      age: age || undefined,
      ageMonth: ageMonth,
      isRevaluationRequired: isRevaluationRequired,
      exclusionType: exclusionType || undefined,
      hireDateType: hireDateType || undefined,
      actualHours: {
        [fields.hours]: values[fields.hours],
        [fields.eligibilityCalculationPeriod]:
          values[fields.eligibilityCalculationPeriod],
        [fields.yearsOfServiceRequirement]:
          values[fields.yearsOfServiceRequirement],
        [fields.serviceCreditPeriod]: values[fields.serviceCreditPeriod],
        [fields.otherComputationalMonths]:
          values[fields.otherComputationalMonths],
        [fields.serviceCreditDay]: values[fields.serviceCreditDay],
      },
      elapsedTime: {
        [fields.period]: values[fields.period],
        [fields.lengthOfService]: values[fields.lengthOfService],
        [fields.eligibilityRequirementMetDate]:
          values[fields.eligibilityRequirementMetDate],
      },
      equivalencyHours: {
        [fields.daily]: values[fields.daily],
        [fields.weekly]: values[fields.weekly],
        [fields.biweekly]: values[fields.biweekly],
        [fields.semiMonthly]: values[fields.semiMonthly],
        [fields.monthly]: values[fields.monthly],
        [fields.quarterly]: values[fields.quarterly],
        [fields.semiAnnually]: values[fields.semiAnnually],
        [fields.annually]: values[fields.annually],
      },
      [fields.excludedClassifications]: [
        ...transformToMultiselectSave(
          (values[fields.excludedClassifications] || []).filter(
            (val) =>
              !get(formValues, fields.excludedClassifications, [])
                .map((_) => _.employeeClassificationCodeId)
                .includes(val)
          ),
          "employeeClassificationCodeId"
        ),
        ...get(formValues, fields.excludedClassifications, [])?.filter((val) =>
          (values[fields.excludedClassifications] || []).includes(
            val.employeeClassificationCodeId
          )
        ),
      ],
    };

    // var eligData = eligibilityListData.map((item, index) => {
    //   if (index === intEligibilityIndex) {
    let transformedData = {};
    if (isEmpty(formValues)) {
      transformedData = {
        ...eligibilityListData,
        additionalEligibilityRules: [
          ...(additionalEligibilityRulesData || []),
          formatedValues,
        ],
      };
      return transformedData;
    }
    transformedData = {
      ...eligibilityListData,
      additionalEligibilityRules: additionalEligibilityRulesData.map(
        (addtionEligibilityItem, addtionEligibilityIndex) => {
          if (addtionEligibilityIndex === parseInt(additionalEligibilityId)) {
            return { ...addtionEligibilityItem, ...formatedValues };
          }
          return addtionEligibilityItem;
        }
      ),
    };
    return transformedData;
    // }
    // return item;
    // });
    // return eligData;
  };
  const onFormSubmit = (values) => {
    dispatch(
      setManagePlanLocalCache({
        model: "eligibilityRules",
        data: getDataForSave(values),
      })
    );
    history.push(
      getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY,
        pathParam: [
          FLOW_TYPES.ADD,
          planId,
          eligibilityIndex,
          planAmendmentId,
          clickedOn,
        ],
        queryParam: `?dirtyCheck=${dirtyCheck}`,
      })
    );
    dispatch(
      setManagePlanToastInfo({
        showToast: true,
        toastMessage: "Data saved successfully",
      })
    );
  };

  const isEdit = newFlow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;

  return (
    <Formik
      initialValues={{
        ...initialValues,
        [fields.excludedClassifications]: formValuesExcludedClassifications?.map(
          (val) => val.employeeClassificationCodeId
        ),
        [fields.eligibilityDescription]: get(
          formValues,
          fields.eligibilityDescription
        ),
        [fields.effectiveStartDate]: get(formValues, `effectiveStartDate`),
        [fields.effectiveEndDate]: get(formValues, `effectiveEndDate`),
        [fields.exclusionType]: get(formValues, `exclusionType`, 2),
        [fields.hireDateType]: get(formValues, `hireDateType`),

        [fields.immediateEligibility]: get(
          formValues,
          fields.immediateEligibility
        ),
        [fields.isBreakInService]: get(formValues, fields.isBreakInService),
        //[fields.isLTPTApplicable]: get(formValues, fields.isLTPTApplicable),
        // [fields.ltptAgeInYears]: get(formValues, fields.ltptAgeInYears),
        // [fields.ltptAgeInMonths]: get(formValues, fields.ltptAgeInMonths),
        // [fields.ltptHours]: get(formValues, fields.ltptHours),
        // [fields.consecutiveYears]: get(formValues, fields.consecutiveYears),
        // [fields.effectiveDate]: get(formValues, fields.effectiveDate),
        // [fields.ltptVestingComputationPeriod]: get(
        //   formValues,
        //   fields.ltptVestingComputationPeriod
        // ),
        // [fields.ltptServiceCreditPeriod]: get(
        //   formValues,
        //   fields.ltptServiceCreditPeriod
        // ),
        // [fields.applicableEmployeeSourceForLTPT]: get(
        //   formValues,
        //   fields.applicableEmployeeSourceForLTPT,
        //   []
        // )?.map((val) => val.sourceId),
        [fields.applicableEligibilityRequirement]: get(
          formValues,
          `${fields.applicableEligibilityRequirement}`
        ),
        [fields.yearsOfServiceDefinition]: get(
          formValues,
          `${fields.yearsOfServiceDefinition}`
        ),
        [fields.age]: get(formValues, `age`),
        [fields.ageMonth]:
          get(formValues, `ageMonth`) == null || undefined
            ? 0
            : get(formValues, `ageMonth`),
        [fields.hours]: get(formValues, `actualHours.${fields.hours}`),
        [fields.otherComputationalMonths]: get(
          formValues,
          `actualHours.${fields.otherComputationalMonths}`
        ),
        [fields.eligibilityCalculationPeriod]: get(
          formValues,
          `actualHours.${fields.eligibilityCalculationPeriod}`
        ),
        [fields.yearsOfServiceRequirement]: get(
          formValues,
          `actualHours.${fields.yearsOfServiceRequirement}`
        ),
        [fields.serviceCreditPeriod]: get(
          formValues,
          `actualHours.${fields.serviceCreditPeriod}`
        ),
        [fields.serviceCreditDay]: get(
          formValues,
          `actualHours.${fields.serviceCreditDay}`,
          2
        ),
        [fields.consecutiveBreaksInService]: get(
          formValues,
          fields.consecutiveBreaksInService
        ),
        [fields.breakInServiceDefinition]: get(
          formValues,
          fields.breakInServiceDefinition
        ),
        [fields.startHireDate]: get(formValues, `startHireDate`),
        [fields.endHireDate]: get(formValues, `endHireDate`),
        [fields.lengthOfService]: get(
          formValues,
          `elapsedTime.${fields.lengthOfService}`,
          1
        ),
        [fields.period]: get(formValues, `elapsedTime.${fields.period}`),
        [fields.eligibilityRequirementMetDate]: get(
          formValues,
          `elapsedTime.${fields.eligibilityRequirementMetDate}`,
          2
        ),
        [fields.daily]: get(
          formValues,
          `equivalencyHours.${fields.daily}`,
          null
        ),
        [fields.monthly]: get(
          formValues,
          `equivalencyHours.${fields.monthly}`,
          null
        ),
        [fields.weekly]: get(
          formValues,
          `equivalencyHours.${fields.weekly}`,
          null
        ),
        [fields.biweekly]: get(
          formValues,
          `equivalencyHours.${fields.biweekly}`,
          null
        ),
        [fields.semiMonthly]: get(
          formValues,
          `equivalencyHours.${fields.semiMonthly}`,
          null
        ),
        [fields.quarterly]: get(
          formValues,
          `equivalencyHours.${fields.quarterly}`,
          null
        ),
        [fields.semiAnnually]: get(
          formValues,
          `equivalencyHours.${fields.semiAnnually}`,
          null
        ),
        [fields.annually]: get(
          formValues,
          `equivalencyHours.${fields.annually}`,
          null
        ),
        // [fields.employeePopulation]: get(formValues, `isRevaluationRequired`),
        // [fields.lengthOfServiceMonths]: get(
        //   formValues,
        //   `${fields.lengthOfServiceMonths}`
        // ),
        // [fields.lengthOfServiceYears]: get(
        //   formValues,
        //   `${fields.lengthOfServiceYears}`
        // ),

        // [fields.eligibilityBreakInServices]: get(
        //   formValues,
        //   fields.eligibilityBreakInServices,
        //   []
        // ).map((item) => item.breakInServiceRuleId),
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setValues,
        values,
        ...rest
      }) => {
        const onDaySelected = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };
        const selectedEmployeeSources =
          values[fields.applicableEmployeeSourceForLTPT];
        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <ManagePlanLayout
              buttons={buttons}
              pageFlow={newFlow || flow}
              layoutHeader={
                additionalEligibilityId && "Additional Eligibility Rule"
              }
              customBreadCrumbs={[
                {
                  label: "Eligibility Rule",
                  link: getPathWithParam({
                    path: MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY,
                    pathParam: [
                      flow,
                      planId,
                      eligibilityIndex,
                      planAmendmentId,
                      clickedOn,
                    ],
                    queryParam: `?dirtyCheck=${dirtyCheck}`,
                  }),
                },
              ]}
            >
              <p className="plan-sub-heading">Eligibility Details</p>
              <Row>
                <Col md="7">
                  <Field
                    isRequired
                    name={fields.eligibilityDescription}
                    label="Eligibility Description"
                    autoComplete="off"
                    value={values[fields.eligibilityDescription]}
                    onChange={handleChange}
                    disabled={isEdit && !isSave}
                    component={FieldTextarea}
                    validate={(value) => {
                      return [undefined, null, ""].includes(value) ||
                        value.trim().length === 0
                        ? "PL534 : Required"
                        : values[fields.eligibilityDescription].trim().length >
                          50
                        ? "PL556 : Eligibility Description length should not Exceed 50 characters"
                        : undefined;
                    }}
                    size="lg"
                  />
                </Col>
              </Row>

              <Row>
                <Col md="4">
                  <Field
                    isRequired
                    label="Effective Start Date"
                    name={fields.effectiveStartDate}
                    value={usDateFormat(values[fields.effectiveStartDate])}
                    disabled={isEdit && !isSave}
                    isDatePicker
                    onClear={() =>
                      setFieldValue(fields.effectiveStartDate, null)
                    }
                    popupContent={
                      <DatePicker
                        onDayClick={(value) => {
                          onDaySelected(fields.effectiveStartDate, value);
                        }}
                        value={usDateFormat(values[fields.effectiveStartDate])}
                      />
                    }
                    validate={(value) => {
                      return [undefined, null, ""].includes(value)
                        ? "PL557 : Required"
                        : undefined;
                    }}
                    component={FieldDropSide}
                  />
                </Col>
              </Row>
              <Row>
                <Col md="4">
                  <Field
                    isRequired
                    label="Effective End Date"
                    name={fields.effectiveEndDate}
                    value={usDateFormat(values[fields.effectiveEndDate])}
                    disabled={isEdit && !isSave}
                    isDatePicker
                    onClear={() => setFieldValue(fields.effectiveEndDate, null)}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) => {
                          onDaySelected(fields.effectiveEndDate, value);
                        }}
                        value={usDateFormat(values[fields.effectiveEndDate])}
                      />
                    }
                    validate={(value) => {
                      return [undefined, null, ""].includes(value)
                        ? "PL558 : Required"
                        : value <= values[fields.effectiveStartDate]
                        ? "PL559 : Eligibility Effective End Date should be greater than Eligibility Effective Start Date"
                        : undefined;
                    }}
                    component={FieldDropSide}
                  />
                </Col>
              </Row>

              <AdditionalExclusionsForm
                {...{
                  fields,
                  values,
                  setValues,
                  isEdit,
                  isSave,
                  onDaySelected,
                  setFieldValue,
                  data: get(planData, "companyId", 0),
                }}
              />

              {/* <p className="plan-sub-heading mt-40">
                Long Term Part Time (LTPT) Eligibility
              </p>
              <Field
                isRequired
                name={fields.isLTPTApplicable}
                label="Is LTPT eligibility Applicable"
                noLabelTransform
                size="sm"
                options={yesNoOptions}
                onChange={(value) => {
                  setFieldValue(fields.isLTPTApplicable, value);
                  setFieldValue(fields.ltptAgeInYears, 21);
                  setFieldValue(fields.ltptHours, 500);
                  setFieldValue(fields.ltptAgeInMonths, null);
                  setFieldValue(fields.consecutiveYears, 3);
                  setFieldValue(fields.effectiveDate, defaultEffectiveDate);
                }}
                selectedValue={values[fields.isLTPTApplicable]}
                component={FieldButtonGroup}
              />

              {values[fields.isLTPTApplicable] == 1 && (
                <>
                  <div className="d-flex">
                    <Field
                      size="lg"
                      isRequired
                      name={fields.ltptAgeInYears}
                      type="number"
                      label="Age"
                      autoComplete="off"
                      onChange={(evt) => {
                        setFieldValue(fields.ltptAgeInYears, evt.target.value);
                      }}
                      validate={(value) => {
                        return [undefined, null, ""].includes(value)
                          ? "PL561 : Required"
                          : values[fields.ltptAgeInYears] <= 21
                          ? "PL562: Eligibility age must be equal to or greater than 21 years and 0 months"
                          : undefined;
                      }}
                      value={values[fields.ltptAgeInYears]}
                      component={FieldInputYearBox}
                    />
                    &nbsp;&nbsp;&nbsp;
                    <div
                      style={{
                        marginLeft: "1rem",
                      }}
                    ></div>
                    <div style={{ marginTop: "2rem" }}>
                      <Field
                        size="md"
                        isRequired
                        name={fields.ltptAgeInMonths}
                        type="number"
                        autoComplete="off"
                        min={1}
                        max={12}
                        onChange={(evt) => {
                          setFieldValue(
                            fields.ltptAgeInMonths,
                            evt.target.value
                          );
                        }}
                        value={values[fields.ltptAgeInMonths]}
                        component={FieldInputMonthBox}
                      />
                    </div>
                  </div>
                  <Field
                    size="xs"
                    isRequired
                    label="Hours"
                    name={fields.ltptHours}
                    type="number"
                    autoComplete="off"
                    onChange={(evt) => {
                      setFieldValue(fields.ltptHours, evt.target.value);
                    }}
                    value={values[fields.ltptHours]}
                    component={FieldInput}
                    validate={(value) => {
                      return [undefined, null, ""].includes(value)
                        ? "PL563 : Required"
                        : values[fields.ltptHours] < 500
                        ? "PL564 : Number of hours of service should not be less than 500"
                        : values[fields.ltptHours] > 1000
                        ? "PL565 : Number of hours of service should not be greater than 1000"
                        : undefined;
                    }}
                  />
                  <Field
                    size="sm"
                    isRequired
                    name={fields.consecutiveYears}
                    type="number"
                    label="Consecutive years"
                    noLabelTransform
                    autoComplete="off"
                    onChange={(evt) => {
                      setFieldValue(fields.consecutiveYears, evt.target.value);
                    }}
                    value={values[fields.consecutiveYears]}
                    component={FieldInputYearBox}
                    validate={(value) => {
                      return [undefined, null, ""].includes(value)
                        ? "Required"
                        : undefined;
                    }}
                  />
                  <Field
                    isRequired
                    name={fields.ltptVestingComputationPeriod}
                    size="sm"
                    label="Eligibilty calculation period"
                    noLabelTransform
                    options={LTPTVestingComputationPeriod}
                    selectedValue={values[fields.ltptVestingComputationPeriod]}
                    onChange={(value) => {
                      setFieldValue(fields.ltptVestingComputationPeriod, value);
                    }}
                    component={FieldButtonGroup}
                    validate={(value) => {
                      return [undefined, null, ""].includes(value)
                        ? "PL559 : Required"
                        : undefined;
                    }}
                  />
                  <Field
                    isRequired
                    name={fields.ltptServiceCreditPeriod}
                    size="sm"
                    label="Service credit period"
                    noLabelTransform
                    options={LTPTServiceCreditPeriod}
                    selectedValue={values[fields.ltptServiceCreditPeriod]}
                    onChange={(value) => {
                      setFieldValue(fields.ltptServiceCreditPeriod, value);
                    }}
                    component={FieldButtonGroup}
                    validate={(value) => {
                      return [undefined, null, ""].includes(value)
                        ? "PL560 : Required"
                        : undefined;
                    }}
                  />
                  <Field
                    label="Applicable Employee Sources"
                    isRequired
                    name={fields.applicableEmployeeSourceForLTPT}
                    value={toMultiSelectValueById(
                      selectedEmployeeSources,
                      employeeSources
                    )}
                    options={employeeSources}
                    isMultiSelect
                    popupContent={
                      <MultiSelectDropdown
                        label="Select Employee Sources"
                        name={fields.applicableEmployeeSourceForLTPT}
                        onSelect={(value) =>
                          setFieldValue(
                            fields.applicableEmployeeSourceForLTPT,
                            value
                          )
                        }
                        value={values[fields.applicableEmployeeSourceForLTPT]}
                        options={employeeSources}
                      />
                    }
                    component={FieldDropSide}
                  />
                  <Field
                    size="sm"
                    isRequired
                    label="Effective date"
                    name={fields.effectiveDate}
                    value={usDateFormat(values[fields.effectiveDate])}
                    isDatePicker
                    placeholder="Effective date"
                    direction="bottom"
                    onClear={() => onDaySelected(fields.effectiveDate, "")}
                    popupContent={
                      <DatePicker
                        onDayClick={(value) =>
                          onDaySelected(fields.effectiveDate, value)
                        }
                        value={values[fields.effectiveDate]}
                      />
                    }
                    component={FieldDropSide}
                    validate={(value) => {
                      return [undefined, null, ""].includes(value)
                        ? "Required"
                        : values[fields.effectiveDate] <= date
                        ? "Effective date cannot be prior to 01/01/2024"
                        : undefined;
                    }}
                  />
                </>
              )} */}
              <DeleteWarning
                DeleteToastMessageHead={DeleteToastMessageHead}
                DeleteToastMessage={DeleteToastMessage}
                showModal={showWarning}
                handleConfirmClick={handleConfirmClick}
                handleCancelClick={handleCancelClick}
              />
              <Modal show={showPopup} onHide={handleClose}>
                <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                  <div className="text-right">
                    <FontAwesomeIcon
                      icon={faTimes}
                      color="#000"
                      onClick={handleClose}
                    />
                  </div>
                  <div className="d-flex">
                    <div className="pd-15">
                      <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        color="#f94f50"
                        size="3x"
                      />
                    </div>
                    <div className="remove-text">
                      {/* <h4>Accept Warning ?</h4> */}
                      <p>{errorMessage}</p>
                      <br />
                      {/* <Button
                        className="remove-btn mr-4"
                        //onClick={onDeleteConfirmClick}
                      >
                        Ok
                      </Button> */}
                      <Button
                        className="cancel-btn"
                        onClick={() => {
                          history.push(
                            getPathWithParam({
                              path: MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY,
                              pathParam: [
                                FLOW_TYPES.SAVE,
                                planId,
                                eligibilityIndex,
                                planAmendmentId,
                                clickedOn,
                              ],
                              queryParam: `?dirtyCheck=${dirtyCheck}`,
                            })
                          );
                        }}
                      >
                        Ok
                      </Button>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>

              <AdditionalEligibilityRuleForm
                {...{ values, fields, isEdit, isSave }}
              />
            </ManagePlanLayout>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AdditionalEligibilityRuleContainer;
